export default __webpack_public_path__ + "static/media/clinic.1314802b.svg";